// extracted by mini-css-extract-plugin
export var addButton = "_c1-0";
export var border = "_c1-8";
export var check = "_c1-h";
export var danger = "_c1-6";
export var dropdownContainer = "_c1-1";
export var editModalBody = "_c1-j";
export var footerContainer = "_c1-i";
export var fullWidth = "_c1-a";
export var hide = "_c1-9";
export var icon = "_c1-3";
export var input = "_c1-7";
export var inputFlex = "_c1-b";
export var inputWrapper = "_c1-c";
export var manualFocus = "_c1-5";
export var optionButton = "_c1-4";
export var pillWrapper = "_c1-e";
export var pointer = "_c1-2";
export var showOverflow = "_c1-f";
export var tagsFlex = "_c1-d";
export var xButton = "_c1-g";